const moment = require("moment");

export const formatDate = (dateString) => {
  return moment(dateString).utcOffset("+05:30").format("DD.MM.YYYY HH:mm");
};
